export default __webpack_public_path__ + "static/media/curfewMob.f2a1d735.jpg";